import React from 'react'
import { createBrowserHistory } from 'history'
import { useLocation, useNavigate, useParams, matchRoutes } from 'react-router-dom'
import { routes } from '../../constants/routes'
import NotFound from '../public/not-found'

export const withRouterProps = (Component) => {
    const Wrapper = (props) => {
        const history = createBrowserHistory()
        const location = useLocation()
        const navigate = useNavigate()
        const params = useParams()
        let myRoutes = Object.keys(routes).map(r => ({ path: routes[r].path }))
        let matches = matchRoutes(myRoutes, location.pathname)
        if (!matches) {
            // Handle the case where no matching routes were found
            return <NotFound />
        }

        let locationParts = matches[0].route.path.split('/').filter(e => e)
        let pathNameParts = location.pathname.split('/').filter(e => e)
        let crumbs = []

        // Build all possible route segments from the current path
        locationParts.forEach((_, i) => {
            let routeSegments = locationParts.slice(0, i + 1)
            let pathSegments = pathNameParts.slice(0, i + 1)
            let routeString = '/' + routeSegments.join('/') + '/'
            let pathString = '/' + pathSegments.join('/') + '/'

            // Find the most specific route that matches this path
            let bestMatch = null
            let maxRouteLength = 0

            Object.keys(routes).forEach(routeKey => {
                const route = routes[routeKey]
                if (route.path === routeString && route.path.length > maxRouteLength) {
                    maxRouteLength = route.path.length
                    bestMatch = {
                        routeKey,
                        route,
                        pathString,
                        routeString
                    }
                }
            })

            if (bestMatch) {
                crumbs.push({
                    path: bestMatch.pathString,
                    label: bestMatch.route.label,
                    routeKey: bestMatch.routeKey,
                    pathSegments: pathSegments
                })
            }
        })

        return (
            <Component
                history={history}
                location={location}
                navigate={navigate}
                params={params}
                crumbs={crumbs}
                {...props}
            />
        )
    }
    return Wrapper
}
